import styled, { keyframes } from "styled-components"

// Animación de spinner
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const FileUploadStyled = styled.div`
  .subtitle {
    color: #374151;
    font-weight: 500;
  }

  .box-file {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 0.25rem;
    padding: 1rem;
    border-radius: 0.5rem;
    border: #dddddd dashed 2px;

    & > button {
      color: #2563eb;
      font-size: 0.875rem;
      line-height: 1.25rem;
      text-decoration: underline;
    }

    &:hover {
      cursor: pointer;
      border-color: #3b82f6;

      & > button {
        color: #1d4ed8;
      }
    }
  }

  .icon {
    width: 2rem;
    height: 2rem;
    color: #9ca3af;
    margin-bottom: 0.5rem;
  }

  .text-error {
    color: #ef4444;
    margin-top: 0.3rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .list-file {
    display: flex;
    padding: 0.5rem;
    margin-top: 0.5rem;
    align-items: center;
    border-radius: 0.25rem;
    background-color: #ffffff;
    justify-content: space-between;

    p {
      flex: 1 1 0%;
      color: #16a34a;
      font-size: 0.875rem;
      line-height: 1.25rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ico-delete {
      color: #ef4444;
      cursor: pointer;
      margin-left: 0.5rem;

      .ico {
        width: 1rem;
        height: 1rem;
      }

      &:hover {
        color: #b91c1c;
      }
    }
  }
    
  .block {
    display: block;
  }
  .hidden {
    display: none;
  }

  .required {
    color: #FD3A4A;
  }

  // Estilos para el estado de loading
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    z-index: 10;
  }

  .loading-spinner {
    width: 24px;
    height: 24px;
    border: 3px solid #e3f2fd;
    border-top: 3px solid #2196f3;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
    margin-bottom: 8px;
  }

  .loading-text {
    color: #1976d2;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0;
  }

  .loading-container {
    position: relative;
  }

  .loading-disabled {
    pointer-events: none;
    opacity: 0.7;
  }
`

export default FileUploadStyled
